<template>
  <div class="w-full bg-white my-6 p-6">
    <div class="mx-auto flex flex-col items-center justify-center">
      <div class="platform-dots relative flex items-center justify-center">
        <div class="size-5 absolute bg-orange-500 rounded-full z-20"></div>
        <div class="size-7 absolute bg-orange-400 rounded-full z-10"></div>
      </div>

      <div class="platform-container max-w-7xl w-full text-center rounded p-2">
        <p class="text-orange-500 text-xs">
          Şu platfromlarda bizden bahsedildi
        </p>
      </div>

      <div class="landing-brands-swiper w-full mt-8">
        <swiper
          :loop="true"
          :modules="modules"
          :navigation="true"
          :pagination="false"
          :draggable="true"
          :slides-per-view="4"
          :space-between="20"
          :breakpoints="{
            '640': {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            '768': {
              slidesPerView: 4,
              spaceBetween: 40,
            },
            '1024': {
              slidesPerView: 5,
              spaceBetween: 60,
            },
            '1664': {
              slidesPerView: 6,
              spaceBetween: 80,
            },
          }"
        >
          <swiper-slide v-for="(image, index) in sliderItems" :key="index">
            <NuxtImg
              :src="`/img/landing-brands/${image.name}`"
              :alt="image.alt"
              height="70"
              :class="`${image.class ? image.class : ''}`"
            />
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { A11y, Navigation, Pagination, Scrollbar } from 'swiper/modules'

import { Swiper, SwiperSlide } from 'swiper/vue'

const modules = [Navigation, Pagination, Scrollbar, A11y]

const sliderItems = ref([
  {
    name: 'benzinga.png',
    alt: 'Benzinga',
  },
  {
    name: 'business-insider.png',
    alt: 'Business Insider',
  },
  {
    name: 'digital-journal.png',
    alt: 'Digital Journal',
  },

  {
    name: 'msn.png',
    alt: 'MSN',
  },
  {
    name: 'barchart.png',
    alt: 'Barchart',
  },

  {
    name: 'yahoo-svgrepo-com.png',
    alt: 'Yahoo',
  },
  {
    name: 'macau-business.png',
    alt: 'Macau Business',
  },
  {
    name: 'associated-press-seek.png',
    alt: 'Associated Press',
    class: 'associated-press-seek',
  },
])

const slideNext = () => {
  const landingSliderElement = document.querySelector('.landing-brands-swiper')
  if (!landingSliderElement) return
  const nextBtn = landingSliderElement.querySelector('.swiper-button-next')
  nextBtn?.click()
}

let timerSwiper: any

onMounted(() => {
  timerSwiper = setInterval(() => {
    slideNext()
  }, 2500)
})

onUnmounted(() => {
  if (timerSwiper) {
    clearInterval(timerSwiper)
  }
})
</script>

<style lang="scss">
.platform-container {
  background-color: rgba(255, 137, 46, 0.2);
}
.platform-dots {
  bottom: 25px;
}
.landing-brands-swiper {
  .swiper {
    max-width: 1920px;
    .swiper-wrapper {
      align-items: center;
      .swiper-slide {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          opacity: 0.5;
        }
        .associated-press-seek {
          min-height: 40px;
        }
      }
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }
}
</style>
